import api from "../api/api";

export const getProfile = async () => {
    const profileRequest = await api().get("users/profile");
    return profileRequest.data;
}
